import {NameRuler} from '@dofleini/validator';
import {proposalrequest} from '@mep/pae-commons';

import CardTypeSelect from '@/components/CardTypeSelect';
import CardTypePreview from '@/components/CardTypeSelect/preview';
import {PROPOSAL_SUBJECT_EXTENDED} from '@/modules/proposalRequest/contants/proposalRequest';
import createClearRenderView from '@/utils/createClearRenderView';

const {SUBJECT_TYPE} = proposalrequest;

export const fields = [
  {
    key: 'code',
    label: 'code',
    renderView: createClearRenderView(),
    required: true,
  },
  {
    key: 'name',
    label: 'name',
    required: true,
    rules: [
      NameRuler
    ]
  },
  {
    key: 'group',
    colSpan: 1,
    label: 'group',
    renderView: createClearRenderView(),
    required: true
  },
  {
    key: 'division',
    label: 'division',
    renderView: createClearRenderView(),
    colSpan: 1,
    required: true
  },
  {
    key: 'section',
    label: 'section',
    renderView: createClearRenderView(),
    colSpan: 1,
    required: true
  },
  {
    key: 'applyFor',
    label: 'CNAENomenclator.form.applyFor.placeholder',
    widget: CardTypeSelect,
    widgetProps: {
      options: [PROPOSAL_SUBJECT_EXTENDED.MIPYMES, SUBJECT_TYPE.TCP_PROPOSAL].map((e) => ({
        label: `common:types.${e}`,
        value: e
      })),
      isCheckBox: true,
      isButton: false,
      fullWidth: false,
      size: 'large',
    },
    viewWidget: CardTypePreview,
    className: 'form-view-mode-vertical-item',
    viewWidgetProps: {
      options: [PROPOSAL_SUBJECT_EXTENDED.MIPYMES, SUBJECT_TYPE.TCP_PROPOSAL].map((e) => ({
        label: `common:types.${e}`,
        value: e
      })),
    }
  },
  {
    key: 'summary',
    onlyEdit: true,
    renderView: createClearRenderView(),
    label: 'CNAENomenclator.form.summary'
  },
  {
    key: 'description',
    label: 'description',
    type: 'html',
    required: true,
    className: 'form-view-mode-vertical-item'
  },
];
